import { render, staticRenderFns } from "./cats.vue?vue&type=template&id=578e4740&scoped=true&"
import script from "./cats.vue?vue&type=script&lang=js&"
export * from "./cats.vue?vue&type=script&lang=js&"
import style0 from "./cats.vue?vue&type=style&index=0&id=578e4740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e4740",
  null
  
)

export default component.exports